import { Typography } from '@material-tailwind/react';

function TdLocaisApc({ item, index }) {
  const isLast = index === item.length - 1;
  const classes = isLast ? 'p-1' : 'p-1 border-b border-blue-gray-50';

  return (
    <tr>
      <td className={classes}>
        <div className="flex items-center gap-3 ">
          <div className="flex flex-col ">
            <Typography
              className="font-extrabold text-black dark:text-black   uppercase ml-2"
              variant="small"
            >
              {item.equipamentoName}
            </Typography>
            <Typography
              variant="small"
              color="black"
              className="font-normal text-xs lowercase ml-2"
            >
              {item.equipamentoTag}
            </Typography>
          </div>
        </div>
      </td>
      <td className={classes}>
        <div className="flex flex-col ">
          <Typography variant="small" color="black" className="font-bold text-center   ">
            {item.quantidade}
          </Typography>
        </div>
      </td>
    </tr>
  );
}

export default TdLocaisApc;
